// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.31.1
// source: Common/VerificationEvents.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "common.events";

/** Verification / code-sent events */
export interface VerificationCodeSentEvent {
  verificationCode: string;
  expiresAt: number;
  /** note: field number 3 was skipped previously; keep compatibility with existing numbering */
  verificationType: string;
}

function createBaseVerificationCodeSentEvent(): VerificationCodeSentEvent {
  return { verificationCode: "", expiresAt: 0, verificationType: "" };
}

export const VerificationCodeSentEvent = {
  encode(message: VerificationCodeSentEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.verificationCode !== "") {
      writer.uint32(10).string(message.verificationCode);
    }
    if (message.expiresAt !== 0) {
      writer.uint32(16).int64(message.expiresAt);
    }
    if (message.verificationType !== "") {
      writer.uint32(34).string(message.verificationType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerificationCodeSentEvent {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerificationCodeSentEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.verificationCode = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.expiresAt = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.verificationType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerificationCodeSentEvent {
    return {
      verificationCode: isSet(object.verificationCode) ? globalThis.String(object.verificationCode) : "",
      expiresAt: isSet(object.expiresAt) ? globalThis.Number(object.expiresAt) : 0,
      verificationType: isSet(object.verificationType) ? globalThis.String(object.verificationType) : "",
    };
  },

  toJSON(message: VerificationCodeSentEvent): unknown {
    const obj: any = {};
    if (message.verificationCode !== "") {
      obj.verificationCode = message.verificationCode;
    }
    if (message.expiresAt !== 0) {
      obj.expiresAt = Math.round(message.expiresAt);
    }
    if (message.verificationType !== "") {
      obj.verificationType = message.verificationType;
    }
    return obj;
  },

  create(base?: DeepPartial<VerificationCodeSentEvent>): VerificationCodeSentEvent {
    return VerificationCodeSentEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<VerificationCodeSentEvent>): VerificationCodeSentEvent {
    const message = createBaseVerificationCodeSentEvent();
    message.verificationCode = object.verificationCode ?? "";
    message.expiresAt = object.expiresAt ?? 0;
    message.verificationType = object.verificationType ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
